import { STAMPReducer } from "../reducer/StampListReducer";

export const reducer = STAMPReducer;
